import React, { Fragment } from 'react';
import styles from './ChecklistField.module.scss';
import { SFCheckbox, SFStateMandatedLabel } from 'sfui';

export interface ChecklistFieldProps {
  label: string;
  items: number[];
  elemLabel: string;
  value: number[];
  required?: boolean;
  helperText?: string;
  error?: boolean;
  showStateMandated?: boolean;
  onChange: (value: number[]) => void;
}

export const ChecklistField = (
  props: ChecklistFieldProps
): React.ReactElement<ChecklistFieldProps> => {
  const value: number[] = props.value ? (props.value as number[]) : [];

  const onCheckboxChange = (index: number, checked: boolean) => {
    if (checked) {
      props.onChange([...value, index]);
    } else {
      props.onChange([
        ...value.slice(0, value.indexOf(index)),
        ...value.slice(value.indexOf(index) + 1)
      ]);
    }
  };

  return (
    <div className={styles.checklistField}>
      {props.items.length > 0 && (
        <Fragment>
          <div className={styles.fieldLabel}>
            {props.showStateMandated && (
              <SFStateMandatedLabel
                label={props.label}
                required={props.required}
              />
            )}
            {!props.showStateMandated && (
              <span>{`${props.label}${props.required ? ' *' : ''}`}</span>
            )}
          </div>
          <ul>
            {props.items.map((item: number) => {
              return (
                <li key={`checklist-item-${item}`}>
                  <SFCheckbox
                    label={`${props.elemLabel} ${item + 1}`}
                    checked={value.indexOf(item) !== -1}
                    onChange={(_e, checked) => onCheckboxChange(item, checked)}
                  />
                </li>
              );
            })}
          </ul>

          {props.helperText && (
            <p
              className={`${styles.helperText} ${
                props.error ? styles.error : ''
              }`}
            >
              {props.helperText}
            </p>
          )}
        </Fragment>
      )}
    </div>
  );
};
